export function normalizeScoredJob(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export interface ScoredJobPartition<T> {
  matched: T[];
  /** Distinct job numbers present on the scored rows that were searched. */
  jobsInFile: string[];
  /** Selected jobs that had no scored row, even after trim and case. */
  missingJobs: string[];
}

export function partitionScoredWelds<T extends { job_number?: string | null }>(
  rows: T[],
  selectedJobNumbers: string[],
): ScoredJobPartition<T> {
  const selected = selectedJobNumbers.map((job) => job.trim()).filter(Boolean);
  const selectedKeys = new Set(selected.map(normalizeScoredJob));
  const jobsInFile: string[] = [];
  const seenFile = new Set<string>();

  rows.forEach((row) => {
    const label = String(row.job_number ?? '').trim();
    const key = normalizeScoredJob(label);
    if (!key || seenFile.has(key)) return;
    seenFile.add(key);
    jobsInFile.push(label);
  });

  const matched = rows.filter((row) => selectedKeys.has(normalizeScoredJob(row.job_number)));
  const matchedKeys = new Set(matched.map((row) => normalizeScoredJob(row.job_number)));
  const missingJobs = selected.filter((job) => !matchedKeys.has(normalizeScoredJob(job)));

  return { matched, jobsInFile, missingJobs };
}
